import React, { useState } from "react";

import Modals from "../popupModal/modal";
import ConfirmationModal from "./ConfirmationModal";

const EnableDisableConciergeServiceModal = ({ isOpen, onSuccess, closeModal, conciergeService, activePatientCount }) => {

  const [isOpenConfirmationModal, setIsOpenConfirmationModal] = useState(false);

  return (
    <Modals
      isOpen={isOpen}
      onRequestClose={() => closeModal}
      title={conciergeService ? "Deactivate Concierge Service" : "Activate Concierge Service"}
      styles={{
        content: {

        },
      }}
      btnDark={{
        label: `${conciergeService ? "Deactivate": "Activate"}`,
        onclick: () => {
          if (conciergeService) {
            setIsOpenConfirmationModal(!isOpenConfirmationModal);
          } else {
            onSuccess();
          }
        },
      }}
      btnOutline={{
        label: "Cancel",
        onclick: () => {
          closeModal();
        },
      }}
    >
      <React.Fragment>
        <button
          onClick={closeModal}
          className="close modalCloseBtn"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        {!conciergeService ? 
				<p className="mx-auto text-center denyAppointmentText">
					<p>
					Provide your patients with premium care through unlimited chat, video calls, and voice calls for $80/month per patient.
					</p>
					<p>
					You’ll earn 80% of the fee while UrgiDoctor retains 20% as a technology service fee.
					</p>
					<p>
					Once activated, your profile will display the Concierge Service badge, letting patients know about this premium offering.
					</p>
					Do you want to activate the Concierge Service?
        </p>
				: 
				<p className="mx-auto text-center denyAppointmentText">
					<p>Are you sure you want to deactivate the Concierge Service?</p>
					<strong>What Happens Next?</strong>
					<p>
						Your profile will no longer display the Concierge Service badge.
						Patients subscribed to this service will lose access to unlimited chat, video calls, and voice calls with you.
					<p>
						Current subscriptions will be terminated at the end of their billing cycle.
					</p>
					If you wish to activate the service later, you can do so at any time from your Settings.
					</p>
				</p>
				}
      </React.Fragment>
      <ConfirmationModal 
      isOpen={isOpenConfirmationModal}  
      titleText="Deactivate Conicerge Service"
      confirmButtonText="Confirm"
      onSuccess={() => {
        onSuccess();
        setIsOpenConfirmationModal(!isOpenConfirmationModal);
        closeModal();
      }}
      closeModal={() => setIsOpenConfirmationModal(!isOpenConfirmationModal)}
      modalContent={
      <p>
        <p>
          Are you sure you want to discontinue the concierge service that you provided to your patient.
        </p>
        <p>{
        activePatientCount > 0 && 
        <p> 
          <p>Refunds for the unused portions of subscriptions will be processed automatically for your patients.</p>
          <p>Currently you have <strong>{activePatientCount} patients</strong>.</p>
        </p>
        }</p>
      </p>
      }
      />
    </Modals>
  );
};

export default EnableDisableConciergeServiceModal;